<template>
  <div class="overview-menu" :class="{ mobile: device === 'mobile' }">
    <div class="info-block">
      <img :src="getImage('meter.svg')" height="21" width="21" alt="meter">
      <span class="title">{{ $t('powerpack.overview.capacity') }}</span>
      <div class="d-flex flex-row justify-content-between">
        <span class="sub-title">{{ $t('powerpack.overview.volumetricFlow') }}</span>
        <span class="total">{{ lpm }} {{ $t('powerpack.overview.lpm') }}</span>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <span class="sub-title">{{ $t('powerpack.overview.maxPressure') }}</span>
        <span class="total">{{ formatMaxPressure(maxPressure, pump).toFixed(2) }} {{ $t('powerpack.overview.bar') }}</span>
      </div>
      <div class="d-flex flex-row justify-content-between"
           v-if="canShowModule(['mini_powerpack', 'open_frame', 'closed_frame', 'workplace', 'industrial'])">
        <span class="sub-title">{{ $t('powerpack.overview.pressureSafety') }}</span>
        <span class="total" :class="exceedingPressureError">{{ pressure }} {{ $t('powerpack.overview.bar') }}</span>
      </div>
    </div>
    <div class="info-block">
      <img :src="getImage('Engine.svg')" height="20" width="30" alt="engine">
      <span class="title">{{ $t('powerpack.overview.motorPower') }}</span>
      <div class="d-flex flex-row justify-content-between">
        <span class="sub-title">{{ $t('powerpack.overview.power') }}</span>
        <span class="total" :class="exceedingPowerError">{{ motor.kw }} Kw</span>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <span class="sub-title">{{ $t('powerpack.overview.motor') }}</span>
        <span class="total" :class="exceedingPowerError">{{ motor.title }}</span>
      </div>
      <span class="error" v-if="exceedingPowerError" v-html="$t('powerpack.overview.exceedingPowerError')"></span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import popup from '../popup/Popup';
import showModuleMixin from '@/mixins/showModuleMixin';

export default {
  name: 'OverviewMenu',

  mixins: [showModuleMixin],

  props: {
    motor: {
      type: Object,
      default: () => {
        return { kw: 0, rpm: 0, price: 0 };
      },
    },
    tank: {
      type: Object,
      default: () => {
        return { liters: 0, price: 0 };
      },
    },
    pump: {
      type: Object,
      default: () => {
        return { cc: 0, price: 0 };
      },
    },
  },
  data() {
    return {
      cc: 0,
      rpm: 0,
      lpm: 0,
      kw: 0,
      error: false,
    };
  },

  components: {
    popup,
  },

  computed: {
    ...mapState({
      isLoading: state => state.preference.isLoading,
      pressure: state => state.preference.safetyPressure,
      liters: state => state.preference.liters,
    }),
    ...mapGetters({
      requiredPower: 'build/requiredPower',
      maxPressure: 'build/maxPressure',
      idealLpm: 'build/lpm',
      idealRpm: 'build/rpm',
      idealCC: 'build/cc',
      device: 'getDevice',
    }),
    exceedingPowerError() {
      if (!this.motor || this.motor.and_pump) return '';
      return this.motor.kw < this.requiredPower ? 'text-danger' : '';
    },
    exceedingPressureError() {
      if (this.motor.and_pump) return '';
      return this.pressure > this.maxPressure ? 'text-danger' : '';
    },
  },
  methods: {
    formatMaxPressure(pressure, pump) {
      if (pressure > pump.max_pressure) {
        return pump.max_pressure;
      } else {
        return pressure;
      }
    },
  },
  watch: {
    idealLpm(newVal, oldVal) {
      //todo nice counting up here?
      this.lpm = newVal;
    },
    idealRpm(newVal, oldVal) {
      this.rpm = newVal;
    },
    idealCC(newVal, oldVal) {
      this.cc = newVal;
    },
  },
  created() {
    const m = this.motor;
    this.rpm = m ? m.rpm : 0;
    this.kw = m ? m.kw : 0;
    this.lpm = this.idealLpm ? this.idealLpm : 0;
  },
};
</script>

<style scoped lang="scss">
.overview-menu {
  height: auto;
  width: 270px;
  background-color: #FAFAFA;
  padding: 20px 16px;
  /*box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.16);*/
  border-right: 3px solid #F0F0F0;
  border-bottom: 3px solid #F0F0F0;

  &.mobile {
    width: 100%;
  }

  .info-block {
    width: 100%;

    &:first-child {
      margin-bottom: 10px;

      @media only screen and (max-width: 768px) {
        margin-bottom: 0;
      }
    }

    .title {
      font-size: 14px;
      max-width: 164px;
      margin-left: 10px;
      margin-right: auto;
      font-family: neue-haas-grotesk-display, sans-serif;
      font-weight: 700;
    }

    div {
      padding-top: 5px;
      align-items: center;

      .sub-title {
        font-size: 12px;
      }

      .total {
        color: #3DB0C7;
        font-size: 12px;
        font-family: neue-haas-grotesk-display, sans-serif;
      }
    }
  }
}

.error {
  margin-top: 4px;
  display: block;
  background-color: lighten(red, 30%);
  border-radius: 10px;
  padding: 4px;
  text-align: center;
  font-size: 11px;
}
</style>
